export var showRemoveFavoritesIcons = id => {
  var elems = document.querySelectorAll("a[class^=fav][data-id='".concat(id, "']"));
  elems.forEach(e => {
    if (e.classList.contains("fav-save")) e.style.display = "none";else if (e.classList.contains("fav-remove")) e.style.display = "block";
  });
};
export var showAddFavoritesIcon = id => {
  var elems = document.querySelectorAll("a[class^=fav][data-id='".concat(id, "']"));
  elems.forEach(e => {
    if (e.classList.contains("fav-save")) e.style.display = "block";else if (e.classList.contains("fav-remove")) e.style.display = "none";
  });
};